import { Button } from "antd";
import { useAppSelector } from "../../../../app/store";
import EditButtonIcon from "../../../../assets/icons/EditButtonIcon";
import Logo from "../../../../assets/images/demo-img.svg";
import InfoItem from "../../../../components/common/InfoItem";
import Loader from "../../../../components/ui/Loader";
import { useGetBusinessDataQuery } from "../../../../features/employee/employeeApi";
import useError from "../../../../hooks/useError";
import useModal from "../../../../hooks/useModal";
import EditCompanyProfileModal from "../edit/EditCompanyProfileModal";

export default function CompanyProfile() {
  const { open, handleOpen, handleClose } = useModal();
  const { authInfo } = useAppSelector((state) => state.auth);
  const {
    data: businessData,
    isError: isBusinessError,
    error: businessError,
    isLoading: isBusinessLoading,
  } = useGetBusinessDataQuery(authInfo?.business_id?.toString() || "", {
    skip: !authInfo?.business_id,
  });
  useError(isBusinessError, businessError, "Get business data fail");

  const companyData = businessData?.data?.business;
  // console.log(companyData);

  return (
    <>
      {open.type === "UPDATE" && (
        <EditCompanyProfileModal open={open.open} handleClose={handleClose} />
      )}
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-body text-xl font-semibold leading-normal">
          Company Profile
        </h2>
        <Button
          className="outline-button-primary !min-w-[151px] h-10"
          icon={<EditButtonIcon />}
          onClick={() => handleOpen({ type: "UPDATE" })}
        >
          Edit
        </Button>
      </div>

      {isBusinessLoading ? (
        <Loader />
      ) : (
        <ul>
          <InfoItem title="Company Logo">
            <div className="h-12">
              <img
                className="h-full object-contain"
                src={companyData?.logo ?? Logo}
                alt=""
              />
            </div>
          </InfoItem>
          <InfoItem title="Company Name">{companyData?.name}</InfoItem>
          {/* <InfoItem title="Company Area">{companyData?.address}</InfoItem> */}
          <InfoItem title="Number of employee">
            {companyData?.employee_size || 0}
          </InfoItem>
          <InfoItem title="Company Address">{companyData?.address}</InfoItem>
        </ul>
      )}
    </>
  );
}
